import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const ExpandableIssueHierarchy = () => {
    return (
        <div>
            <h2>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.expandable-issue-hierarchy-spork.title"
                    defaultMessage="Expandable issue hierarchy"
                />
            </h2>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.expandable-issue-hierarchy-spork.bodyOne"
                    defaultMessage="In Jira, issue hierarchy levels show the relationship between issue types, from big units of work to small. Expandable issue hierarchy allows you to custom create additional issue levels to visualize everything from quarterly goals down to daily tasks within a plan."
                />
            </p>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.expandable-issue-hierarchy-spork.learnMore"
                    defaultMessage="<learnMore>Learn more</learnMore> about issue hierarchy."
                    values={{
                        ...DEFAULT_VALUES,
                        learnMore: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="jiraSoftware"
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                href={useLocalizedHref(
                                    "/software/jira/guides/advanced-roadmaps/overview#how-do-i-customize-issue-hierarchy"
                                )}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};

export default ExpandableIssueHierarchy;
